import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import CryptoAES from 'crypto-js/aes';
import CryptoENC from 'crypto-js/enc-utf8';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Background from 'Img/bg.png';

import {
  Profile,
  ControlPanel,
  Settings,
  Login,
  Register,
  ModaleConferma,
  Report,
  Messaggi,
  SideBar,
  ModaleSMS,
  PasswordRecovery,
  PasswordRecoveryForm
} from 'Containers/main_layout';
import {
  NuovoOspite,
  Devices,
  NuovoDispositivo,
  Guests,
  PuntoControllo,
  DeviceQrCode,
  DeviceAccessKeypad,
  Tessere
} from 'Containers/functions';

class MainLayout extends React.Component {
  constructor(props) {
    super(props);
    const config = require('../../../../config/config.json');

    // decrypt & toast message come here...
    let urlKey = "";
    if (window.location.href.includes("?dmd=")) {
      urlKey = window.location.href.split("?dmd=")[1];
    }
    let toastMessage = "";
    if (urlKey) {
      toastMessage = CryptoAES.decrypt(urlKey, config.phrase).toString(CryptoENC);
    } else if (window.location.href.includes("2r3c2practivated131c")) {
      setTimeout(() => this.props.logout(), 500);
      toastMessage = "Account attivato con successo.";
    }

    this.state = { config };

    if (toastMessage) {
      toast.info(toastMessage, {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  }

  hideSideBar(e) {
    const id = e.target.id;
    const txt = e.target.outerText;
    const cls = e.target.className;
    const ptxt = e.target.parentElement.innerText;
    const pptext = e.target.parentElement.parentElement.outerText;
    if (
      id !== "sidebar" &&
      !(cls && cls.includes("sidebar-btn")) &&
      !["ControlPanel","Punti controllo","Chiavi"].includes(txt) &&
      !["ControlPanel","Punti controllo","Chiavi"].includes(ptxt) &&
      !["ControlPanel","Punti controllo","Chiavi"].includes(pptext)
    ) {
      this.props.setSideBarVisibility(false);
    }
  }

  render() {
    this.props.getStompClient();
    $(() => {
      if (this.props.isThemeDark()) {
        $("body").css("background", "black");
      }
    });

    const contextPath = process.env.CONTEXT_PATH || '';
    const publicKeypadPath = `${contextPath}/public_keypad`;
    const isPublicKeypadRoute = window.location.pathname === publicKeypadPath || window.location.pathname === `${publicKeypadPath}/`;

    if (isPublicKeypadRoute) {
      return (
        <main role="main" id="main">
          <Routes>
            <Route path={process.env.CONTEXT_PATH + '/public_keypad'} element={<DeviceAccessKeypad />} />
            <Route path="*" element={<DeviceAccessKeypad />} />
          </Routes>
        </main>
      );
    }

    return (
      <>
        {this.props.getUser() ? (
          (this.props.deviceSetupProcedureStarted || this.props.guestRegistrationProcedureStarted) ? (
            <Routes>
              <Route path={process.env.CONTEXT_PATH + '/nuovo_dispositivo'} element={<NuovoDispositivo />} />
              <Route path={process.env.CONTEXT_PATH + '/dispositivi'} element={<Devices />} />
              <Route path={process.env.CONTEXT_PATH + '/nuovo_ospite'} element={<NuovoOspite />} />
            </Routes>
          ) : (
            <>
              <main
                role="main"
                id="main"
                style={{
                  background: this.props.isThemeDark()
                    ? 'black'
                    : `linear-gradient(rgba(255,255,255,.9), rgba(255,255,255,.9)), url(${Background})`,
                  height: "100vh"
                }}
              >
                <Routes>
                  <Route path={process.env.CONTEXT_PATH + '/settings'} element={<Settings />} />
                  <Route path={process.env.CONTEXT_PATH + '/messaggi'} element={<Messaggi />} />
                  <Route path={process.env.CONTEXT_PATH + '/report'} element={<Report />} />
                  <Route path={process.env.CONTEXT_PATH + '/nuovo_dispositivo'} element={<NuovoDispositivo />} />
                  <Route path={process.env.CONTEXT_PATH + '/guests'} element={<Guests />} />
                  <Route path={process.env.CONTEXT_PATH + '/tessere'} element={<Tessere />} />
                  <Route path={process.env.CONTEXT_PATH + '/nuovo_ospite'} element={<NuovoOspite />} />
                  <Route path={process.env.CONTEXT_PATH + '/dispositivi'} element={<Devices />} />
                  <Route path={process.env.CONTEXT_PATH + '/punto_controllo'} element={<PuntoControllo />} />
                  <Route path={process.env.CONTEXT_PATH + '/device_qr_code'} element={<DeviceQrCode />} />
                  <Route path={process.env.CONTEXT_PATH + '/control_panel'} element={<ControlPanel />} />
                  <Route path={process.env.CONTEXT_PATH + '/profile'} element={<Profile />} />
                  <Route path="*" element={<Navigate to={process.env.CONTEXT_PATH + '/dispositivi'} />} />
                </Routes>
              </main>
              <SideBar />
              <ModaleConferma />
              <ModaleSMS />
              <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar
                newestOnTop={false}
                closeOnClick
                pauseOnFocusLoss
                draggable
                pauseOnHover
              />
            </>
          )
        ) : (
          <main role="main" id="main">
            <Routes>
              <Route path={process.env.CONTEXT_PATH + '/auth'} element={<Login />} />
              <Route path={process.env.CONTEXT_PATH + '/password_recovery'} element={<PasswordRecovery />} />
              <Route path={process.env.CONTEXT_PATH + '/password_recovery_f'} element={<PasswordRecoveryForm />} />
              <Route path={process.env.CONTEXT_PATH + '/register'} element={<Register />} />
              <Route path="*" element={<Navigate to={process.env.CONTEXT_PATH + '/auth'} />} />
            </Routes>
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar
              newestOnTop={false}
              closeOnClick
                pauseOnFocusLoss
                draggable
                pauseOnHover
              />
          </main>
        )}
      </>
    );
  }
}

export default MainLayout;
export { MainLayout };
